import { HttpMethod } from '@nu-art/thunderstorm-shared';
import { DBDef_OrganizationPermission } from './db-def.js';
export const ApiDef_OrganizationPermission = {
    _v1: {
        changeOrganizationOwnership: { method: HttpMethod.POST, path: `v1/${DBDef_OrganizationPermission.dbKey}/assign-organization-permission` },
    }
};
//# sourceMappingURL=api-def.js.map